import { Component, HostListener, OnDestroy } from "@angular/core";
import { ShareService } from '../../../services/share.service'
import { ApiserviceService } from '../../../../apiservice.service';
import { NotificationService } from '../../../services/notification.service';
import { AppNotificationService } from '../../../services/app-notification.service';
import { AdminBreadcrumbService } from '../../../admin-breadcrumb/services/admin-breadcrumb.service';
import { Subscription } from "rxjs";
 

/**
 *
 * <strong>List of API using</strong>
 * <ol>
 * <li>estapi_module_type_notification_user_id_get</li>
 * <li>estapi_module_type_notification_user_id_patch</li>
 * </ol>
 *
 */
@Component({
  selector: 'app-notify-details',
  templateUrl: './notify-detail.component.html',
  styleUrls: ['../notification/notification.component.css']
})
export class NotifyDetailComponent implements OnDestroy {
  height: number;
  height2: number;
  offset: number = 0;
  limit: number = 50;
  loader: boolean = false;
  notification_list: any = [];
  selected_notification: any;
  private subs = new Subscription();
  constructor(private readonly share: ShareService,
    private readonly api: ApiserviceService,
    private readonly notify: NotificationService,
    private readonly _crumbs: AdminBreadcrumbService,
    private readonly alert: AppNotificationService) {
    this.share.notify_obj = this;
    this._crumbs.addcrumb = { title: 'Notifications' };
    this._crumbs.mobiletitle = 'Notifications';
    this._crumbs.count = 1;
    this.onResize();
    this.getNotifications();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.height = (window.innerHeight - 125);
    this.height2 = this.height - 20;
  }
  getDate(v) {
    let date = new Date(v);
    let month = date.getMonth() + 1;
    let format = date.getDate() + '-' + month + '-' + date.getFullYear();
    return format;
  }
  getTime(v) {
    let date = new Date(v);
    let format = date.getHours() + ':' + date.getMinutes();
    return format;
  }
  getNotifications(offset = 0, limit = 50, scroll = false) {
    this.loader = true;
    let url = `deapp/notification/${this.api.user_id}?notification_status=sent,read&offset=${offset}&limit=${limit}&sort_by=added_date`;
    const notifiSub = this.api.getEmsData(url).subscribe(
      {
        next: (res:any) => {
          this.loader = false;
          if(Array.isArray(res)){
            if (!scroll) {
              this.notification_list = res;
            } else {
              res.forEach(n => {
                this.notification_list.push(n);
              });
            }
          }
        },
        error:() => {
          this.loader = false;
        },
        complete() {
          this.loader = false;
        },
      }
    )
    this.subs.add(notifiSub);
  }
  markAsRead(n) {
    this.selected_notification = n;
    if (n.email_status != 'read') {
      let user_id = this.api.user_id;
      let url = `deapp/notification/${user_id}`;
      let data = {
        "email_status": "read",
        "notification_id": n.notification_id,
        "updated_by": this.api.user_id
      }
      const markAsReadSub = this.api.patchEmsData(url, data).subscribe((data:any) => {
        this.getNotifications();
        this.alert.getCount();
      });
      this.subs.add(markAsReadSub);
    }
  }
  markAllAsRead(){
    let user_id = this.api.user_id;
    let url = `deapp/notification/${user_id}`;
    let data = {
      "mark_all_as_read": true,
      "updated_by": this.api.user_id,
      "notification_id": 0
    };
    const markAllAsRead = this.api.patchEmsData(url, data).subscribe({
      next: () => {
        this.getNotifications();
        this.alert.getCount();
      },
      error: (err) => {
        console.log("Mark all as read error:", err);
      }
    });
    this.subs.add(markAllAsRead);
  }
  isSelected(i) {
    if (i && this.selected_notification) {
      if (this.selected_notification.notification_id == i.notification_id) {
        return true;
      } else {
        return false;
      }
    }

  }
  onScroll(e) {
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
